/* Rose & Fire — site-wide behaviour. Loaded on every page, before rf-pdp.js. */
(function () {
  'use strict';

  /* ---------------------------------------------------------------------
     Cart bridge. This build is served as static files, so there is no
     /cart/add.js on this origin. Every add falls through to a Shopify cart
     permalink on www.roseandfire.com, which puts the same variant ids in the
     real cart. If the same markup is ever served from the store itself, the
     AJAX path is used instead and the theme's drawer still opens.
     --------------------------------------------------------------------- */
  var SHOP = 'https://www.roseandfire.com';
  var onStore = window.RF_ON_STORE === true || /(^|\.)roseandfire\.com$/i.test(location.hostname);

  /* The ad promises 20% off, so every hand-off to Shopify carries the code.
     UPGRADE is the live code (switched from ROSE20 on 2026-09-22); CLEAR / ROSE25 /
     SAVE25 do not exist and error out at checkout. Set to '' to turn the
     auto-apply off. */
  var DISCOUNT = '';

  function permalink(items, note) {
    var pairs = items.map(function (i) { return i.id + ':' + (i.quantity || 1); }).join(',');
    var url = SHOP + '/cart/' + pairs + '?storefront=true';
    if (DISCOUNT) url += '&discount=' + encodeURIComponent(DISCOUNT);
    if (note) url += '&attributes[Gift note]=' + encodeURIComponent(String(note).slice(0, 250));
    return url;
  }
  function drawerOrCart() {
    try { document.dispatchEvent(new Event('ajax-cart:changed')); } catch (e) {}
    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    document.dispatchEvent(new CustomEvent('cart:build', { bubbles: true }));
    setTimeout(function () {
      if (!document.querySelector('.drawer.is-open, cart-drawer[open], .cart-drawer.active, #CartDrawer.active')) {
        window.location.href = '/cart';
      }
    }, 400);
  }
  function addError(msg) {
    var btn = document.querySelector('[data-n-atc]');
    if (!btn) return;
    var p = btn.parentNode.querySelector('.n-err');
    if (!p) { p = document.createElement('p'); p.className = 'n-err'; p.setAttribute('role', 'alert');
      p.style.cssText = 'color:#c8102e;font-size:14px;margin:10px 0 0;text-align:center';
      btn.insertAdjacentElement('afterend', p); }
    p.textContent = (msg && msg !== 'add failed') ? msg : 'Could not add to the bag. Please try again.';
  }
  window.RFCART = {
    onStore: onStore,
    shop: SHOP,
    discount: DISCOUNT,
    url: function (path) { return onStore ? path : SHOP + path; },
    add: function (items, opts) {
      opts = opts || {};
      if (!items || !items.length) return;
      if (!onStore) { window.location.href = permalink(items, opts.note); return; }
      fetch('/cart/add.js?sc-silently-change-cart=true', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (r) { return r.json().catch(function () { return {}; }).then(function (j) {
          if (!r.ok) throw new Error(j.description || j.message || 'add failed'); return j; }); })
        .then(function (j) { if (!opts.note) return j;
          return fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ attributes: { 'Gift note': String(opts.note).slice(0, 250) } }) })
            .then(function () { return j; }, function () { return j; }); })
        .then(function () {
          if (opts.onDone) opts.onDone();
          if (opts.redirect) { window.location.href = '/cart'; return; }
          drawerOrCart();
        })
        .catch(function (err) {
          if (opts.onFail) opts.onFail();
          if (onStore) { addError(err && err.message); return; }
          window.location.href = permalink(items, opts.note);
        });
    }
  };

  /* ---------------------------------------------------------------------
     Back button.

     Every add navigates away to the Shopify cart, and the button that was
     clicked is disabled immediately before that navigation. Chrome and Safari
     then restore this page from the back/forward cache with the DOM frozen
     exactly as it was, so the button comes back still disabled and the page
     looks broken. The success callback never runs, because we left the page
     before it could.

     Buttons whose LABEL is owned by a section (the buy box rewrites its own
     price, the set builder its total) register a reset hook on window.RF_RESET
     instead of having their markup restored from here.
     --------------------------------------------------------------------- */
  window.RF_RESET = window.RF_RESET || [];

  function restoreButtons() {
    var sel = '[data-rf-atc],[data-rf-atc2],[data-rf-xadd],[data-rf-notifyform] button';
    [].slice.call(document.querySelectorAll(sel)).forEach(function (b) {
      b.disabled = false;
      b.classList.remove('is-added');
    });
    [].slice.call(document.querySelectorAll('[data-rf-xcard].is-open')).forEach(function (c) {
      c.classList.remove('is-open');
    });
    window.RF_RESET.forEach(function (fn) { try { fn(); } catch (e) {} });
  }

  window.addEventListener('pageshow', restoreButtons);
  window.addEventListener('focus', restoreButtons);
  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) restoreButtons();
  });

  /* ---------- mobile nav ---------- */
  var burger = document.querySelector('[data-rf-burger]');
  var nav = document.querySelector('[data-rf-nav]');
  if (burger && nav) {
    burger.addEventListener('click', function () {
      var open = nav.classList.toggle('is-open');
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  /* ---------- analytics on listing surfaces ----------
     A card carries its handle in the href, and the catalog is keyed by variant,
     so list events report the product page rather than a variant id. */
  (function () {
    if (!window.RFTRACK) return;
    var listName = (document.querySelector('h1') || {}).textContent || document.title;
    RFTRACK.pageView(document.querySelector('[data-rf-collgrid]') ? 'collection'
                    : (/index\.html$|\/$/.test(location.pathname) ? 'home' : 'page'));
    var cards = [].slice.call(document.querySelectorAll('.rf-card'));
    if (cards.length) {
      RFTRACK.viewItemList(listName.trim(), cards.slice(0, 24).map(function (c) {
        var a = c.querySelector('.rf-card__name');
        return { id: (a.getAttribute('href') || '').replace('.html', ''),
                 qty: 1, info: { p: a.textContent.trim(), v: '', c: 0 } };
      }));
    }
    document.addEventListener('click', function (ev) {
      var card = ev.target.closest && ev.target.closest('.rf-card');
      if (!card) return;
      var a = card.querySelector('.rf-card__name');
      RFTRACK.selectItem(listName.trim(), {
        id: (a.getAttribute('href') || '').replace('.html', ''),
        qty: 1, info: { p: a.textContent.trim(), v: '', c: 0 }
      });
    });
  })();

  /* ---------- collection filter + sort ----------
     Filtering is client side on data attributes so the grid stays instant and
     the page keeps working with no build step behind it. */
  var grid = document.querySelector('[data-rf-collgrid]');
  if (grid) {
    var chips = [].slice.call(document.querySelectorAll('[data-rf-filter]'));
    var countEl = document.querySelector('[data-rf-count]');
    var cards = [].slice.call(grid.children);

    function apply(key) {
      var shown = 0;
      cards.forEach(function (c) {
        var tags = (c.getAttribute('data-tags') || '').split(' ');
        var hit = key === 'all' || tags.indexOf(key) !== -1;
        c.hidden = !hit;
        if (hit) shown++;
      });
      if (countEl) countEl.textContent = shown + (shown === 1 ? ' design' : ' designs');
      chips.forEach(function (ch) { ch.classList.toggle('is-on', ch.getAttribute('data-rf-filter') === key); });
      if (window.RFTRACK && key !== 'all') RFTRACK.filter(key, shown);
      try { history.replaceState(null, '', key === 'all' ? location.pathname : '?f=' + key); } catch (e) {}
    }
    chips.forEach(function (ch) {
      ch.addEventListener('click', function () { apply(ch.getAttribute('data-rf-filter')); });
    });
    var start = new URLSearchParams(location.search).get('f');
    apply(start && chips.some(function (c) { return c.getAttribute('data-rf-filter') === start; }) ? start : 'all');
  }
})();
